// extracted by mini-css-extract-plugin
export default {"icon-container":"FilterPanelOpener_icon-container__QZJkr","iconContainer":"FilterPanelOpener_icon-container__QZJkr"};